export default __webpack_public_path__ + "9c6b780b7ed8c667bcf2b2341fa9626a.png";